import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon, ArrowLeftIcon, HomeIcon } from 'lucide-react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { useLanguage } from '../contexts/LanguageContext';
export function ThankYouPage() {
  const {
    t,
    getPath,
    navigate
  } = useLanguage();
  useEffect(() => {
    // Fire Meta Pixel Lead event when the Thank You page loads
    if (typeof window !== 'undefined') {
      if (window.fbq) {
        window.fbq('track', 'Lead');
      } else {
        setTimeout(() => {
          if (window.fbq) window.fbq('track', 'Lead');
        }, 1000);
      }
    }
  }, []);
  return <div className="min-h-screen w-full flex flex-col" style={{
    backgroundColor: 'var(--bg-primary)'
  }} data-id="element-865">
      <Navigation data-id="element-866" />

      <section className="flex-1 flex items-center justify-center px-4 py-32" data-id="element-867">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-center max-w-lg" data-id="element-868">
          <motion.div initial={{
          scale: 0
        }} animate={{
          scale: 1
        }} transition={{
          delay: 0.2,
          type: 'spring',
          stiffness: 200
        }} className="w-24 h-24 mx-auto mb-8 rounded-full flex items-center justify-center" style={{
          backgroundColor: 'var(--accent)'
        }} data-id="element-869">
            <CheckCircleIcon className="w-12 h-12 text-white" data-id="element-870" />
          </motion.div>

          <h1 className="text-3xl sm:text-4xl font-bold mb-4" style={{
          color: 'var(--text-primary)'
        }} data-id="element-871">
            {t('thankyou.title')}
          </h1>

          <p className="text-lg mb-8" style={{
          color: 'var(--text-secondary)'
        }} data-id="element-872">
            {t('thankyou.desc')}
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-873">
            <a href={getPath('')} onClick={e => {
            e.preventDefault();
            navigate('');
          }} className="inline-flex items-center gap-2 px-6 py-3 rounded-xl text-sm font-semibold transition-all hover:scale-105" style={{
            backgroundColor: 'var(--bg-secondary)',
            color: 'var(--text-primary)',
            border: '1px solid var(--border)'
          }} data-id="element-874">
              <ArrowLeftIcon className="w-4 h-4" data-id="element-875" />
              {t('nav.home')}
            </a>
          </div>
        </motion.div>
      </section>

      <Footer data-id="element-876" />
    </div>;
}